export const HELP_ONBOARDING_STEP_INFO = {
  formTitle: "Getting Started Step",
  formTitleForNew: "New Getting Started Step",
  path: "/helponboardingsteps",
  listPage: "/help-onboarding-steps",
}

export const HELP_ONBOARDING_STEP_FORM_TEMPLATE = {
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "helpOnboardingStep",
      fieldItems: [
        {
          label: "Sort Order",
          type: "text",
          name: "sortOrder",
          initialFocus: true,
        },
        {
          label: "Section Title (optional — set this to start a new grouped part of the checklist, e.g. \"Part 1: Stock\". Leave blank to continue the previous section.)",
          type: "text",
          name: "sectionTitle",
          initialFocus: false,
        },
        {
          label: "Title",
          type: "text",
          name: "title",
          initialFocus: false,
          validationProps: {
            required: "Title is required",
          }
        },
        {
          label: "Description",
          type: "text",
          name: "desc",
          initialFocus: false,
          validationProps: {
            required: "Description is required",
          }
        },
        {
          label: "Guide (optional — shown as \"Guide coming soon\" if left blank)",
          type: "select",
          name: "helpArticle",
          required: false,
          initialFocus: false,
          url: "/helparticleoptions",
        },
      ]
    },
  },
  watchFields: []
}
